import script from "./SubformView.vue?vue&type=script&setup=true&lang=js"
export * from "./SubformView.vue?vue&type=script&setup=true&lang=js"

import "./SubformView.vue?vue&type=style&index=0&id=2e910dc6&lang=scss"

const __exports__ = script;

export default __exports__